<template>
  <div class="collect-page paperRepari-page">
    <div class="mains-content flex-row">
      <div class="page-left">
        <div class="member-box"><member ref="memberSearch" @handleUser="memberChange"></member></div>
        <div class="right-box">
          <div v-if="form.length == 0 ? true:false" class="right-box-empty">
            <div class="right-box-empty-img">
              <img src="../../../assets/images/new/fooBath_empty.png" alt="">
            </div>
          </div>
          <div v-else>
            <div class="contents-body">
              <div class="contents-scoll">
                <div class="contents-boxs mb10" v-for="(item,index) in orderList" :key="index">
                  <div class="p16">
                    <div class="mb16 fb fontSize18">{{item.categoryName}}</div>
                    <div class="align-items mb16">
                      <span>登记金额</span>
                      <span>￥{{item.amount}}</span>
                    </div>
                    <div class="align-items mb16">
                      <span>顾客姓名</span>
                      <span>{{item.docMemberName}}</span>
                    </div>
                    <div class="align-items mb16">
                      <span v-if="item.choseType == 'number'">数量</span>
                      <span v-else>部位</span>
                      <span class="symptom-Name">{{item.symptom}}{{item.choseType == 'number' ? '个':''}}</span>
                    </div>
                    <div class="align-items mb16">
                      <span>技师</span>
                      <span>{{item.staffNames}}</span>
                    </div>
                    <div class="align-items">
                      <span>下次登记时间</span>
                      <span>{{item.nextRepairTime}}</span>
                    </div>
                  </div>
                  <div class="flex-end bdT ptb16 pr16">
                    <div class="cur" @click="edit(item)"><img src="../../../assets/images/new/edit.png" alt=""></div>
                    <div class="ml30 cur" @click="del(item,index)"><img src="../../../assets/images/new/deleted.png" alt=""></div>
                  </div>
                </div>
              </div>
              <div class="confirm-btn">
                <div class="flex-row space-between">
                  <div class="msg">
                    <div class="nums total">
                      总数量: {{orderList.length}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
			  </div>
        <div class="flex-row moreOperations">
          <el-button class="left_btn" @click="pendingOrder">挂单</el-button>
          <el-button class="save_btn" @click="handConfim">确定开卡</el-button>
        </div>
      </div>
      <div class="left-box">
        <div class="card-all scroll-auto">
          <div class="repair-title">
            <div class="card-box" :class="[item.show?'active':'',activeName == index ? 'active':'']" v-for="(item,index) in list" :key="index" @click="handleChangeList(item,index)">
              <div class="card-msg">
                <!-- <img class="img" :src="item.url" alt /> -->
                <p>{{ item.categoryName }}</p>
                <div class="addRepair">添加档案</div>
              </div>
              <div class="repair_jia"><img src="../../../assets/images/new/repair_jia.png" alt=""></div>
              <div class="payCheak" v-if="item.show || activeName == index"><img src="../../../assets/images/new/payRadio.png" alt=""></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" center style="margin-top: 20vh;">
      <span style="color: red;text-align: center;display: inline-block;width: 100%;">确定要挂单吗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handConfim('pendingOrder')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="orderVisible" width="50%" :close-on-click-modal="false" :before-close="cancel">
      <div slot="title">
        <div class="align-item">
          <div class="fonSize18 fb">添加档案</div>
          <el-divider direction="vertical"></el-divider>
          <div class="fonSize18 fb">{{form.categoryName}}</div>
        </div>
      </div>
      <el-form ref="form" :model="form" class="demo-ruleForm " label-width="200px" label-position="left">
        <el-row>
          <el-col :span="12">
            <el-form-item class="el-form-item-update" ref="staffName" prop="staffName">
              <div slot="label">
                档案金额<span class="moneys ml10">{{form.priceRange}}</span>
              </div>
              <el-input v-model="form.amount" placeholder="请输入档案金额" maxlength="8" @keyup.native="form.amount = isMoney(form.amount)" clearable="" class="right-content-price"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              class="el-form-item-update"
              ref="docMemberName"
              label="顾客姓名"
              prop="docMemberName"
            >
              <el-input v-model="form.docMemberName" readonly="" @focus="handDocMember" class="right-content-price"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              class="el-form-item-update"
              ref="staffName"
              label="服务技师"
              prop="staffName"
            >
              <el-select v-model="form.staffIds" placeholder="请选择" class="w100b">
                <el-option
                  v-for="item in staffOptions"
                  :key="item.value"
                  :label="item.staffName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              class="el-form-item-update"
              ref="staffName"
              :label="(form.categoryId == 'c' || form.categoryId == 'd') ?'数量':'部位'"
              prop="staffName"
            >
              <el-cascader v-model="form.parts" :options="options" :props="props" clearable v-if="form.categoryId == 'b'" class="w100b"></el-cascader>
              <el-cascader v-model="form.parts" :options="fingerOption" :props="props" clearable v-else-if="form.categoryId == 'a'" class="w100b"></el-cascader>
              <el-cascader v-model="form.parts" :options="handFootOption" :props="props" clearable v-else-if="form.categoryId == 'e'" class="w100b"></el-cascader>
              <el-input v-model="form.parts" readonly v-else-if="form.categoryId == 'f'"></el-input>
              <el-autocomplete class="inline-input w100b"  v-else v-model="form.symptom" clearable :fetch-suggestions="querySearch" placeholder="请输入自定义数量" :maxlength="3"></el-autocomplete>
              <!-- <el-select v-model="form.symptom" placeholder="请选择">
                <el-option v-for="item in numList" :key="item.name" :label="item.value" :value="item.name"></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              class="el-form-item-update"
              ref="nextRepairTime"
              label="下次登记时间"
              prop="nextRepairTime"
            >
              <el-date-picker class="dates cur w100b" :editable="false" v-model="form.nextRepairTime" value-format="yyyy-MM-dd" type="date" align="right" placeholder="请选择"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              class="el-form-item-update"
              label="登记照片（1-3张）"
            >
              <imgUpload @file="getFile" :limit="3" :fileList="form.imgUrlList" @delete="handleDelete" :imgHide="imgHide" module="repair"></imgUpload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              class="el-form-item-update"
              label="备注"
            >
              <el-input type="textarea" :rows="5" :autosize="{ minRows: 5, maxRows: 10}" placeholder="请输入备注" v-model="form.remark" maxlength="150" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="saveMoney">确 定</el-button>
      </span>
    </el-dialog>
    <set-money ref="setMoneyForm" @handleChange="handleReset"></set-money>
    <search-member ref="searchMemberForm" @change="selectMembered"></search-member>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import imgUpload from "../../../components/common/modules/upload";
import member from "../../components/member";
import searchMember from './searchMember.vue';
import setMoney from "./setMoney";
export default {
  mixins: [minxin],
  components: {imgUpload, member, setMoney,searchMember},
  data() {
    return {
      pageHeight: this.$store.getters.MainHeight - 70 + "px",
      memberHide: true, //false,
      dialogVisibleHide: false,
      orderVisible: false,
      formMobile: "",
      dialogVisible: false,
      list: [],
      imgHide: true,
      repairTitile: "请选择档案部位",
      props: { multiple: true },

      options: [
        {
          value: '左脚',
          label: '左脚',
          children: [
            {value: '大拇指', label: '大拇指',},
            {value: '食指', label: '食指'},
            {value: '中指', label: '中指'},
            {value: '无名指', label: '无名指'},
            {value: '小指', label: '小指'}
          ]
        }, 
        {
          value: '右脚',
          label: '右脚',
          children: [
            {value: '大拇指', label: '大拇指',},
            {value: '食指', label: '食指'},
            {value: '中指', label: '中指'},
            {value: '无名指', label: '无名指'},
            {value: '小指', label: '小指'}
          ]
        },
        {
          value: '左手',
          label: '左手',
          children: [
            {value: '大拇指', label: '大拇指',},
            {value: '食指', label: '食指'},
            {value: '中指', label: '中指'},
            {value: '无名指', label: '无名指'},
            {value: '小指', label: '小指'}
          ]
        },
        {
          value: '右手',
          label: '右手',
          children: [
            {value: '大拇指', label: '大拇指',},
            {value: '食指', label: '食指'},
            {value: '中指', label: '中指'},
            {value: '无名指', label: '无名指'},
            {value: '小指', label: '小指'}
          ]
        }
      ],
      staffOptions: [],
      handFootOption: [
        {
          value: '左手',
          label: '左手',
        },
        {
          value: '右手',
          label: '右手'
        },
        {
          value: '左脚',
          label: '左脚'
        },
        {
          value: '右脚',
          label: '右脚'
        },
      ],
      fingerOption: [
        {
          value: '左手',
          label: '左手',
          children: [
            {value: '大拇指内侧', label: '大拇指内侧',},
            {value: '大拇指外侧', label: '大拇指外侧'},
            {value: '食指内侧', label: '食指内侧'},
            {value: '食指外侧', label: '食指外侧'},
            {value: '中指内侧', label: '中指内侧'},
            {value: '中指外侧', label: '中指外侧'},
            {value: '无名指内侧', label: '无名指内侧'},
            {value: '无名指外侧', label: '无名指外侧'},
            {value: '小指内侧', label: '小指内侧'},
            {value: '小指外侧', label: '小指外侧'},
          ]
        },
        {
          value: '右手',
          label: '右手',
          children: [
            {value: '大拇指内侧', label: '大拇指内侧',},
            {value: '大拇指外侧', label: '大拇指外侧'},
            {value: '食指内侧', label: '食指内侧'},
            {value: '食指外侧', label: '食指外侧'},
            {value: '中指内侧', label: '中指内侧'},
            {value: '中指外侧', label: '中指外侧'},
            {value: '无名指内侧', label: '无名指内侧'},
            {value: '无名指外侧', label: '无名指外侧'},
            {value: '小指内侧', label: '小指内侧'},
            {value: '小指外侧', label: '小指外侧'},
          ]
        },
        {
          value: '左脚',
          label: '左脚',
          children: [
            {value: '大拇指内侧', label: '大拇指内侧',},
            {value: '大拇指外侧', label: '大拇指外侧'},
            {value: '食指内侧', label: '食指内侧'},
            {value: '食指外侧', label: '食指外侧'},
            {value: '中指内侧', label: '中指内侧'},
            {value: '中指外侧', label: '中指外侧'},
            {value: '无名指内侧', label: '无名指内侧'},
            {value: '无名指外侧', label: '无名指外侧'},
            {value: '小指内侧', label: '小指内侧'},
            {value: '小指外侧', label: '小指外侧'},
          ]
        },
        {
          value: '右脚',
          label: '右脚',
          children: [
            {value: '大拇指内侧', label: '大拇指内侧',},
            {value: '大拇指外侧', label: '大拇指外侧'},
            {value: '食指内侧', label: '食指内侧'},
            {value: '食指外侧', label: '食指外侧'},
            {value: '中指内侧', label: '中指内侧'},
            {value: '中指外侧', label: '中指外侧'},
            {value: '无名指内侧', label: '无名指内侧'},
            {value: '无名指外侧', label: '无名指外侧'},
            {value: '小指内侧', label: '小指内侧'},
            {value: '小指外侧', label: '小指外侧'},
          ]
        },
      ],
      form: {
        imgUrlList: [],
        remark: "",
        amount: "",
        staffIds: "",
        categoryId: "a",
        nextRepairTime: "", //下次修护时间  new Date()
        parts: [],
        symptom: "",
        docMemberId: '',
        docMemberName: '',
        // amount: "200",
        // categoryId: "b",
        // categoryName: "灰指甲",
        // choseType: "finger",
        // imgUrlList: Array(3),
        // nextRepairTime: "2022-07-29",
        // parts: Array(5),
        // priceRange: "0-1000",
        // remark: "2",
        // staffIds: "09C441519D462B9D",
        // symptom: "左脚-大拇指;左脚-食指;左脚-中指;左脚-无名指"
      },
      orderList: [],
      totalAmount: 0,
      memberId: "",
      orderIndex: null,
      restaurants: [],
      activeName: null,
      title: '',
      
      oldMemberList: []
    };
  },
  created() {
    this.getRepairItem();
    this.getStaffList();
  },
  mounted() {
    this.restaurants = this.loadAll();
  },
  methods: {
    querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      loadAll() {
        return [
          {name: 1, value: '1'},
          {name: 2, value: '2'},
          {name: 3, value: '3'},
          {name: 4, value: '4'},
          {name: 5, value: '5'},
          {name: 6, value: '6'},
          {name: 7, value: '7'},
          {name: 8, value: '8'},
          {name: 9, value: '9'},
          {name: 10, value: '10'},
        ];
      },
    edit (item) {
      // 编辑
      this.form = this.deepClone(item);
      this.orderVisible = true;
    },
    del (item,index) {
      this.orderList.splice(index, 1);
      this.activeName = null;
      this.list.map(res => {
        if (res.categoryId == item.categoryId) {
          res.show = false;
        }
      })
    },
    getStaffList () {
      this.$api.post(this.$url.companyShopStaff.listOnWork, {
        status: "enable"
      }).then(res => {
        if (res) {
          this.staffOptions = res;
        }
      })
    },
    getRepairItem() {
        this.$api.post(this.$url.repairDocument.listRepairItem).then(res => {
            res.map(item => {
              item.show = false;
              item.repairItemFormList = [];
            })
            this.list = res;
        })
    },
    pendingOrder () {
      if (!this.memberId) {
        this.$message.warning("请选择会员");
        return false;
      } else if (this.orderList.length == 0) {
        this.$message.warning("请选择部位");
        return false;
      }
      this.dialogVisible = true;
    },
    getFile(res) {
      this.form.imgUrlList.push(res);
      if (this.form.imgUrlList.length >= 3) {
          this.imgHide = false
      }
    },
    handleDelete(res) {
      this.form.imgUrlList = res.myFileList;
      this.ossMerchatDelImg(res);
      if (this.form.imgUrlList.length < 3) {
          this.imgHide = true
      }
    },
    memberChange(value) {
      console.log(value);
      this.memberId = value.id;
      this.form.docMemberId = value.id;
      this.form.docMemberName = value.nickName + "(" + value.mobile + ")";
      this.oldMemberList = value;
      if (value != "") {
        this.memberHide = true;
      } else {
        this.memberHide = false;
      }
    },
    handleChangeList(item, index) {
        if (!this.memberId) return this.$message.warning("请选择会员");
        this.activeName = index;
        this.$api.get(this.$url.repairDocument.checkBuildRight,{memberId: this.memberId,categoryId:this.list[index].categoryId}).then(res => {
          if (res) {
            this.orderVisible = true;
            if (item.categoryId == "f") {
              this.form.parts = "不限"
            }
            console.log(item);
            this.form.categoryId = item.categoryId;
            this.form.categoryName = item.categoryName;
            this.form.choseType = item.choseType;
            this.form.priceRange = item.priceRange;
          }
        })
    },
  
    saveMoney() {
      console.log(this.form);
      if (!this.form.categoryId) return this.$message.warning("请选择档案分类");
      if (!this.form.amount) return this.$message.warning("请输入档案金额");
      if (!this.form.staffIds) return this.$message.warning("请选择技师");
      if ((this.form.categoryId == "a" || this.form.categoryId == "b" || this.form.categoryId == "e") && this.form.parts.length == 0) {
        return this.$message.warning("请选择部位");
      } else if ((this.form.categoryId == "c" || this.form.categoryId == "d") && !this.form.symptom) {
        return this.$message.warning("请选择数量");
      }
      if (!this.form.nextRepairTime) {
        this.$message.warning("请选择下次登记时间");
        return false;
      }
      if (this.form.imgUrlList.length < 1) {
        this.$message.warning("请上传至少一张照片");
        return false;
      }
      if (!this.form.remark) {
        this.$message.warning("请输入备注");
        return false;
      }
      if (this.form.choseType == "finger" || this.form.choseType == 'handFootDetail' || this.form.choseType == 'handFoot') {
        let as = [];
        this.form.parts.map(item => {
          let obj = item.join("-");
          as.push(obj)
        })
        this.form.symptom = as.join(";");
      } else if (this.form.choseType == 'common') {
        this.form.symptom = "";
      }
      this.staffOptions.map(item => {
        if (this.form.staffIds == item.id) {
          this.form.staffNames = item.staffName;
        }
      })
      
      let array = this.deepClone(this.form)
      if (this.orderList.length == 0) {
          this.orderList.push(array);
      } else {
        this.orderIndex = null;
        var data = this.orderList.some((item,index) => {
            this.orderIndex = index;
            return item.categoryId == array.categoryId;
        })
        if (data) {
          this.$set(this.orderList, this.orderIndex, array);
        } else {
          this.orderList.push(array);
        }
      }
      this.list.map(item => {
        this.orderList.map(i=> {
          if (item.categoryId == i.categoryId) {
            item.show = true;
          }
        })
      })
      this.cancel();
    },
    cancel () {
      this.form = {
        docMemberId: '',
        docMemberName: '',
        imgUrlList: [],
        remark: "",
        amount: "",
        staffIds: "",
        staffName: "",
        categoryId: "",
        categoryName: "",
        nextRepairTime: "", //下次修护时间  new Date()
        parts: [],
        symptom: ""
      }
      this.orderVisible = false;
      this.imgHide = true;
      this.form.docMemberId = this.oldMemberList.id;
      this.form.docMemberName = this.oldMemberList.nickName + "(" + this.oldMemberList.mobile + ")";
    },
    // 定义一个深拷贝函数  接收目标target参数
    deepClone(target) {
        // 定义一个变量
        let result;
        // 如果当前需要深拷贝的是一个对象的话
        if (typeof target === 'object') {
        // 如果是一个数组的话
            if (Array.isArray(target)) {
                result = []; // 将result赋值为一个数组，并且执行遍历
                for (let i in target) {
                    // 递归克隆数组中的每一项
                    result.push(this.deepClone(target[i]))
                }
            // 判断如果当前的值是null的话；直接赋值为null
            } else if(target===null) {
                result = null;
            // 判断如果当前的值是一个RegExp对象的话，直接赋值    
            } else if(target.constructor===RegExp){
                result = target;
            }else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
                result = {};
                for (let i in target) {
                    result[i] = this.deepClone(target[i]);
                }
            }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
        } else {
            result = target;
        }
        // 返回最终结果
        return result;
    },
    // 开卡 
    handConfim (pendingOrder) {
      if (!this.memberId) {
        this.$message.warning("请选择会员");
        return false;
      } else if (this.orderList.length == 0) {
        this.$message.warning("请选择部位");
        return false;
      }
      let parmar = {
        memberId: this.memberId,
        repairItemFormList: this.orderList
      }
      this.$api.post(this.$url.repairDocument.saveBatch, parmar).then(res => {
        if (res) {
          if (pendingOrder == "pendingOrder") {
            this.$message.success("挂单成功");
            this.dialogVisible = false;
            this.handleReset(true);
          } else {
            this.$refs["setMoneyForm"].$emit("set", res);
          }
        }
      });
    },
    handleReset (org) {
      // 支付成功回调
      if (org) {
        this.activeName = null;
        this.orderList = [];
        this.$refs.memberSearch.handleInputHide();
        this.list.map(item => {
          item.show = false;
        })
      }
    },
    handDocMember () {
      // 触发选择其他顾客
      this.$refs.searchMemberForm.$emit("set", true)
    },
    selectMembered (org) {
      console.log(org,'org2');
      if (org) {
        this.form.docMemberId = org.id;
        this.form.docMemberName = org.nickName + "(" + org.mobile + ")";
        console.log(this.form, 'axz');
        console.log(this.form.docMemberName, 'axz1');
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
.paperRepari-page {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #F5F5F5;
  }
}
.mains-content {
  display: flex;
  height: 100%;
  .left-box {
    width: 60%;
    border-radius: 10px;
    background-color: #fff;
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .card-all {
      height: 100%;
      .repair-title {
        display: flex;
        flex-wrap: wrap;
        padding: 16px;
        .card-box {
          width: calc(32% - 46px);
          position: relative;
          height: 124px;
          margin-right: 2%;
          margin-bottom: 20px;
          border-radius: 5px;
          padding: 20px;
          border: 1px solid #ecf6ff;
          background: #ecf6ff;
          border-radius:10px;
          
          cursor: pointer;
          .addRepair {
            padding: 9px 12px;
            color: #fff;
            background: #3388FF;
            border-radius: 20px;
            position: absolute;
            bottom: 20px;
          }
          .repair_jia {
            position: absolute;
            right: 0;
            bottom: 20px;
            img {
              width: 100%;
              height: 100%;
              vertical-align: top;
            }
          }
          &:nth-of-type(3n) {
            margin-right: 0 !important;
          }
        }
        p {
          font-size: 24px;
          font-weight: 700;
        }
        .active {
          border: 1px solid #3388FF;
          border-radius: 5px;
          p {
            
            color: #4e89f8;
          }
        }
      }
    }
  }
    .confirm-btn {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-top: 1px solid @borderColor;
      height: 62px;
      .flex-row {
        
        align-items: center;
        .msg {
          display: flex;
          flex: 1;
          font-weight: 500;
          .nums {
            margin-right: 13px;
          }
        }
      }
    }
}
.page-left {
  width: 40%;
}
.moreOperations {
  width: calc(100% - 16px);
  .left_btn {
    width: 30%;
    height: 68px;
    font-size: 20px;
    font-weight: bold;
    margin-top: 15px;
    color: #fff;
    background: #535A6C;
  }
  .save_btn {
    width: 70%;
    height: 68px;
    font-size: 20px;
    font-weight: bold;
    margin-top: 15px;
    color: #fff;
    background: #FF5449;
  }
}

.goodName {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
 .member-box {
    width: calc(100% - 48px);
    padding: 9px 16px;
    background: #3388ff;
    border-radius: 10px 10px 0px 0px;
	}
  .right-box {
		background: url("../../../assets/images/new/footBath.png") no-repeat;
    background-position:center bottom;
    height: calc(100vh - 239px);
    margin-right: 16px;
		.right-box-empty {
      height: calc(100vh - 239px);
      display: flex;
      justify-content: center;
      align-items: center;
      .right-box-empty-img {
        width: 191px;
        height: 170px;
      }
    }
		.contents-body {
			.tables-title {
        font-size: 14px;
        padding: 13px 16px;
        background: #F7F8FA;
			}
			.tables {
				padding: 0 0 16px;
				height: calc(100vh - 430px);
				box-sizing: border-box;
				.boxs {
					padding: 18px 16px 0;
					box-sizing: border-box;
					.money {
						color: @money;
						font-weight: 500;
					}
					.delete {
						font-size: 18px;
						cursor: pointer;
						&:hover {
							color: @blue;
						}
					}
				}
				.right-content {
					margin-top: 15px;
					display: flex;
          padding-bottom: 16px;
          border-bottom: 1px solid #EBEDF0;
				}
			}
		}
	}
.paperRepari-page {
  height: calc(100vh - 58px);
  background-color: #e6edf5;
  padding: 16px;
  .groupDialog /deep/ .el-dialog__body {
    padding: 10px 20px;
    color: #111;
    height: 200px;
    overflow: auto;
  }
}
.contents-body {
  padding: 16px;
  .contents-scoll {
    overflow: auto;
    height: calc(100vh - 326px);
  }
  .contents-boxs {
    background: #f7f8fa;
    border: 1px solid #f7f8fa;
    border-radius: 4px;
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
}
.demo-ruleForm {
  // overflow: auto;
  height: 500px;
  
}
.symptom-Name {
  display: inline-block;
  width: 70%;
  text-align: right;
}
.payCheak {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 0;
  right: 0;
}
</style>